import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, of } from "rxjs";
import { hasFilterValue, IGroup, IPayload, IRegion, Payload, toStringList } from "../interface/filters";
import { ApplicationService } from "./application.service";

import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import * as _ from 'lodash';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

import moment from "moment";
import { Role } from "../enums/role";
import { MeUser, userHasCsiProfile } from "./models/me-user";

import { P } from "@angular/cdk/keycodes";
import { AuthService } from "./auth.service";
import { QuestionsService } from "./questions.service";
import { NetworkFilterValues } from "../shared/filters/network-form";
import { FilterBrand } from "../shared/filters/filter-market";
import { environment } from "src/environments/environment";

export interface SettingsPayload {
  payload: Payload;
  state: "valid" | "init" | "transition";
}

@Injectable({
  providedIn: "root",
})
export class MyUtils {
  public ROLE_DEALER: string = "DEALER";
  public ROLE_DEALER_JP: string = "DEALER_JP";
  public ROLE_ADMIN: string = "ADMIN";
  public ROLE_STELLANTIS_HQ: string = "STELLANTIS-HQ";
  public ROLE_IMPORTER: string = "IMPORTER";
  public ROLE_SUBREGION: string = "SUBREGION";
  public ROLE_IAP_ADMIN: string = "IAP-ADMIN";
  public MASERATI_DEFAULT_BRAND: string = "b_MASE";
  public IAP_DEFAULT_REGION: string = "IAP";
  public DEALER_GROUP: string = "DEALER_GROUP";
  public MASERATI_ADMIN: string = "MASERATI_ADMIN";
  public MASERATI_SUBREGION: string = "MASERATI_SUBREGION";
  public MASERATI_IMPORTER: string = "MASERATI_IMPORTER";
  public MASERATI_DEALER: string = "MASERATI_DEALER";
  public IAP_DEALER: string = "IAP_DEALER";
  public MEA: string = "MEA";
  public ROLE_HELP_DESK_LINK: string = "HELP_DESK_LINK";
  public ADMIN_SA: string = "ADMIN-SA";
  public IMPORTER_DR: string = "IMPORTER-DR";
  public ROLE_IMPORTER_UPLOAD: string = "IMPORTER-UPLOAD";
  public DEALER_UPLOAD: string = "DEALER-UPLOAD";
  public ROLE_APPEAL_REGION: string = "ROLE-APPEAL-REGION";
  public ROLE_APPEAL_MARKET: string = "ROLE-APPEAL-MARKET";
  public ROLE_APPEAL_DEALER: string = "ROLE-APPEAL-DEALER";
  public ROLE_IMPORTER_MEA: string = "IMPORTER-MEA"

  public palette: string[] = [
    "#3366cc",
    "#dc3912",
    "#ff9900",
    "#109618",
    "#990099",
    "#0099c6",
    "#dd4477",
    "#66aa00",
    "#b82e2e",
    "#316395",
    "#3366cc",
    "#994499",
    "#22aa99",
    "#aaaa11",
    "#6633cc",
    "#e67300",
    "#8b0707",
    "#651067",
    "#329262",
    "#5574a6",
    "#3b3eac",
    "#b77322",
    "#16d620",
    "#b91383",
    "#f4359e",
    "#9c5935",
    "#a9c413",
    "#2a778d",
    "#668d1c",
    "#bea413",
    "#0c5922",
    "#743411",
  ];
  public ROLE_DEFAULT: string = "ROLE_DEFAULT";
  traslate: any;
  public payload!: IPayload;

  public printSubject: BehaviorSubject<any>;
  public printSelect: Observable<any>;

  public settingsPayloadSubject: BehaviorSubject<SettingsPayload>;
  public settingsPayloadSelect: Observable<SettingsPayload>;

  public settingsPerformanceQuestionSubject: BehaviorSubject<any>;
  public settingsPerformanceQuestionSelect: Observable<any>;

  public storagePayload: string | null;

  // remoteQuestions:any[] = []

  remoteQuestions: { [propr: string]: any; } = {}

  constructor(private applicationService: ApplicationService) {
    this.storagePayload = localStorage.getItem("settingsPayload");
    let emptyPayload: SettingsPayload = {
      payload: new Payload(),
      state: "init",
    };
    let parsedPaylod: SettingsPayload = this.storagePayload ? JSON.parse(this.storagePayload) : emptyPayload;
    parsedPaylod.state = "init";
    this.settingsPayloadSubject = new BehaviorSubject<SettingsPayload>(parsedPaylod);
    this.settingsPayloadSelect = this.settingsPayloadSubject.asObservable();

    this.settingsPerformanceQuestionSubject = new BehaviorSubject<any>(
      //JSON.parse(localStorage.getItem("settingsPerformanceQuestion")!
      null
    );
    this.settingsPerformanceQuestionSelect = this.settingsPerformanceQuestionSubject.asObservable();

    this.printSubject = new BehaviorSubject<any>(JSON.parse(localStorage.getItem("printValue")!));
    this.printSelect = this.printSubject.asObservable();


  }

  public initSettingsPerformanceQuestion() {
    let savedSettings = localStorage.getItem("settingsPerformanceQuestion");
    if (savedSettings) {
      let parsedSettings = JSON.parse(savedSettings);
      this.settingsPerformanceQuestionSubject.next(parsedSettings);
    }
  }

  public setPrintSubject(print: any) {
    localStorage.setItem("printValue", JSON.stringify(print));
    this.printSubject.next(<any>print);
  }
  public get getPrintValue() {
    return this.printSubject.value;
  }

  /*   public setSettingsPerformanceQuestionValue(questions: any) {
    localStorage.setItem("settingsPerformanceQuestion", JSON.stringify(questions));
    this.settingsPerformanceQuestionSubject.next(<any>questions);
  } */
  public get settingsPerformanceQuestionValue() {
    return this.settingsPerformanceQuestionSubject.value;
  }

  public setSettingsPayloadValue(settingsPayload: SettingsPayload) {
    localStorage.setItem("settingsPayload", JSON.stringify(settingsPayload));
    this.settingsPayloadSubject.next(settingsPayload);
  }

  public resetSettingsPayload(): void {
    const emptySettings: SettingsPayload = {
      payload: new Payload(),
      state: "init",
    };
    localStorage.removeItem("settingsPayload");
    this.settingsPayloadSubject.next(emptySettings);
  }

  public get settingsPayloadValue() {
    return this.settingsPayloadSubject.value;
  }

  public randomColor() {
    return "#" + Math.floor(Math.random() * 16777215).toString(16);
  }


  public traslatei18n(key: string, fatherKeyTraslate?: string): string {
    this.traslate = this.applicationService.translationListSelectValue.data;

    if (fatherKeyTraslate) {
      key = `${fatherKeyTraslate}.${key}`;
    }
    if (this.applicationService.translationListSelectValue.region === 'key-KEY') {
      return '{( ' + key + ' )}'
    }


    let columns: string[] = [];
    try {
      columns = key ? key.split(".") : [];
    } catch (e) {
      return "";
    }
    let value = this.traslate;

    const englishTransation = this.applicationService.translationListSelectValue.en;
    columns.forEach((element: any) => {

      let key2 = element.toLowerCase();
      if (this.remoteQuestions && this.remoteQuestions[key2]) {
        value = this.remoteQuestions[key2];
      } else if (value && value[element]) {
        value = value[element];
      } else if (englishTransation && englishTransation[element]) {
        value = englishTransation![element]
      }
      else {
        value = "";
      }
    });

    return value && typeof value === "string" ? value : key;
  }

  translateChip(value: string | string[] | undefined, fatherKeyTraslate: string | undefined) {
    if (!value) return "";
    if (Array.isArray(value)) {
      let stringVal = Array.isArray(value) ? value[0] : value;
      let translation = this.traslatei18n(stringVal, fatherKeyTraslate);
      if (value.length > 1) {
        translation += " + " + (value.length - 1);
      }
      return translation;
    }
    return this.traslatei18n(value, fatherKeyTraslate);
  }

  tooltip(object: any) {
    let matTooltip: any = [];
    object.value.forEach((element: any) => {
      matTooltip.push(this.traslatei18n(element, object?.fatherKeyTraslate));
    });
    return matTooltip.join(", \n\b");
  }

  public isMaseratiAdmin(user: any) {
    return user.csiProfile === this.ROLE_ADMIN && user.brand === this.MASERATI_DEFAULT_BRAND;
  }

  public userRoleAdminModuleAppealRegion(): any {
    return this.ROLE_APPEAL_REGION;
  }
  public userRoleAdminModuleAppealMarket(): any {
    return this.ROLE_APPEAL_MARKET;
  }
  public userRoleAdminModuleAppealDealer(): any {
    return this.ROLE_APPEAL_DEALER;
  }

  public userRole(user: any) {
    let profile = user.csiProfile;
    let brand = user.pathbrand;
    let region = user.region;

    if (brand === this.MASERATI_DEFAULT_BRAND) {
      if (region === this.ROLE_SUBREGION) {
        return this.MASERATI_SUBREGION;
      } else {
        switch (profile) {
          case this.ROLE_ADMIN:
            return this.MASERATI_ADMIN;
          case this.ROLE_IMPORTER:
            return this.MASERATI_IMPORTER;
          case this.ROLE_DEALER:
            return this.MASERATI_DEALER;
          default:
            return user.csiProfile;
        }
      }
    } else {
      switch (profile) {
        case this.ROLE_DEALER: {
          return region === this.IAP_DEFAULT_REGION ? this.IAP_DEALER : this.ROLE_DEALER;
        }
        default:
          return user.csiProfile;
      }
    }
  }

  generateIdChart() {
    let key = Math.random().toString(36).slice(2);
    return key;
  }

  initPayload(me: any, filterSessionSelected?: NetworkFilterValues) {
    let payload: IPayload = new Payload();

    payload.network.brand = me.pathbrand === "#" ? me.scopeEntities?.network?.brand : [me.pathbrand];

    let subregions = [];
    let markets = [];
    if (me.market) {
      markets.push(me.market);
    } else {
      let regionSelect = me?.scopeEntities.network.regions.find((el: any) => el.region === me.region);

      // scopeEntities.network.regions carries one subRegions entry per subregion. With
      // ssoHarmonization on: scope markets to the user's home subregion when they have
      // one, else aggregate markets from every subregion of the region — instead of
      // always taking only the first subregion, which fed the initial dealer fetch a
      // too-narrow market list before any filter control had a chance to widen it.
      if (environment.featureFlags.ssoHarmonization) {
        markets = me.subRegion
          ? regionSelect.subRegions.find((sr: any) => sr.subregion === me.subRegion)?.market || []
          : regionSelect.subRegions.flatMap((sr: any) => sr.market);
      } else {
        markets = regionSelect.subRegions[0].market;
      }
    }

    subregions = [
      {
        market: markets,
        subregion: me.subRegion || "",
      },
    ];

    let region = {
      region: me.region,
      subRegions: subregions,
    };
    if (filterSessionSelected) {
      subregions = [
        {
          market: [],
          subregion: filterSessionSelected.subregion || "",
        },
      ];

      region = {
        region: filterSessionSelected.region,
        subRegions: subregions,
      };
    }
    const allowedSections = this.getAvailableSections(me)

    payload.network.regions = [region];
    payload.period.datePreset = "months_iso";

    const momentLocale = moment.locale();

    if (momentLocale.startsWith('ar')) {
      const locale = 'en';
      moment.locale(locale);
    }

    payload.period.current.from = moment().startOf("M").format("YYYY-MM-DD");
    payload.period.current.to = moment().format("YYYY-MM-DD");

    payload.period.previous.from = moment().subtract(1, "M").startOf("M").format("YYYY-MM-DD");
    payload.period.previous.to = moment().subtract(1, "M").endOf("M").format("YYYY-MM-DD");

    payload = Object.assign(payload, { extraFilters: { allowedSections } })

    this.setSettingsPayloadValue({ payload: payload, state: "init" });

    return payload;
  }

  getAvailableSections(user: MeUser) {
    return user?.menu.reduce((sections: string[], menuItem: any) => {
      if (menuItem.itemType !== "Journey") return sections;
      sections.push(menuItem.idItem)
      return sections
    }, [])
  }

  setBrandNetworkPayload(brand: string[], pay: IPayload) {
    let payload: IPayload = pay;

    payload.network.brand = brand && brand.length > 0 ? brand : [""];
    // this.setSettingsPayloadValue({ payload: payload, state: "valid" });
    return payload;
  }

  setRegionsNetworkPayload(regions: string | undefined, pay: IPayload) {
    let payload: IPayload = pay;
    payload.network.regions = [{ region: regions || "", subRegions: [{ market: [""], subregion: "" }] }];
    payload.network.dealer = [];
    // this.setSettingsPayloadValue({ payload: payload, state: "valid" });
    return payload;
  }

  setSubRegionsNetworkPayload(subregion: string, pay: IPayload) {
    let payload: IPayload = pay;
    payload.network.regions[0].subRegions = [{ market: [""], subregion: subregion }];
    // this.setSettingsPayloadValue({ payload: payload, state: "valid" });
    return payload;
  }

  setGroupNetworkPayload(groupIn: any, pay: IPayload) {
    let payload: IPayload = pay;
    let group: IGroup = payload.network.group;
    group.type = groupIn ? groupIn.title : "";
    group.value = groupIn ? groupIn.value.key : "";
    payload.network.group = group;
    // this.setSettingsPayloadValue({ payload: payload, state: "valid" });
    return payload;
  }

  setMarketNetworkPayload(market: any, pay: IPayload) {
    let payload: IPayload = pay;
    let region: IRegion[] = payload.network.regions;
    region[0].subRegions[0].market = market && market.length > 0 ? market : [""];
    payload.network.regions = region;
    // this.setSettingsPayloadValue({ payload: payload, state: "valid" });
    return payload;
  }

  setDistributorNetworkPayload(distributor: string[], pay: IPayload) {
    let payload: IPayload = pay;
    payload.network.distributor = distributor ? distributor : [""];
    // this.setSettingsPayloadValue({ payload: payload, state: "valid" });
    return payload;
  }

  setZoneNetworkPayload(zone: string | string[], pay: IPayload) {
    let payload: IPayload = pay;
    payload.network.zone = zone;
    // this.setSettingsPayloadValue({ payload: payload, state: "valid" });
    return payload;
  }

  setAreaNetworkPayload(area: string | string[], pay: IPayload) {
    let payload: IPayload = pay;
    payload.network.area = area;
    // this.setSettingsPayloadValue({ payload: payload, state: "valid" });
    return payload;
  }

  setDealerNetworkPayload(dealer: string[], pay: IPayload) {
    let payload: IPayload = pay;
    payload.network.dealer = dealer && dealer.length > 0 ? dealer : [""];
    // this.setSettingsPayloadValue({ payload: payload, state: "valid" });
    return payload;
  }

  setAgentNetworkPayload(agent: string[], pay: IPayload) {
    let payload: IPayload = pay;
    payload.network.agent = agent && agent.length > 0 ? agent : [""];
    // this.setSettingsPayloadValue({ payload: payload, state: "valid" });
    return payload;
  }

  setOutletNetworkPayload(outlet: string[], pay: IPayload) {
    let payload: IPayload = pay;
    payload.network.outlet = outlet && outlet.length > 0 ? outlet : [""];
    // this.setSettingsPayloadValue({ payload: payload, state: "valid" });
    return payload;
  }

  setDatePayload(currentDate: any, previousDate: any, pay: IPayload) {
    let payload: IPayload = pay;
    payload.period.current.from = currentDate.end;
    payload.period.current.to = currentDate.end;

    payload.period.previous.from = previousDate.end;
    payload.period.previous.to = previousDate.end;

    // this.setSettingsPayloadValue({ payload: payload, state: "valid" });
    return payload;
  }

  setTypeVeichlePayload(type: string | string[], pay: IPayload) {
    let payload: IPayload = pay;

    // Multi-select (isMultipleSelect): send an empty array, not "", when nothing is selected.
    payload.vehicle.modelType = hasFilterValue(type) ? type : [];
    // this.setSettingsPayloadValue({ payload: payload, state: "valid" });
    return payload;
  }

  setModelVeichlePayload(model: string | string[], pay: IPayload) {
    let payload: IPayload = pay;

    // Multi-select (isMultipleSelect): send an empty array, not "", when nothing is selected.
    payload.vehicle.model = hasFilterValue(model) ? model : [];
    // this.setSettingsPayloadValue({ payload: payload, state: "valid" });
    return payload;
  }

  setEngineVeichlePayload(engine: string | string[], pay: IPayload) {
    let payload: IPayload = pay;

    // Multi-select (isMultipleSelect): send an empty array, not "", when nothing is selected.
    payload.vehicle.engine = hasFilterValue(engine) ? engine : [];
    // this.setSettingsPayloadValue({ payload: payload, state: "valid" });
    return payload;
  }

  setDataPeriodPayload(current: any, previous: any, pay: IPayload) {
    let payload: IPayload = pay;
    payload.period.current.from = current.start.format("YYYY-MM-DD");
    payload.period.current.to = current.end.format("YYYY-MM-DD");

    payload.period.previous.from = previous.start.format("YYYY-MM-DD");
    payload.period.previous.to = previous.end.format("YYYY-MM-DD");

    // this.setSettingsPayloadValue({ payload: payload, state: "valid" });
    return payload;
  }
  /*   reset() {
    this.setSettingsPayloadValue(null);
  } */

  parseEuropeanDate(dateString: string | undefined) {
    let date: Date | undefined = undefined;
    if (dateString) {
      let dateArray = dateString.split("/");
      date = new Date(Number(dateArray[2]), Number(dateArray[1]) - 1, Number(dateArray[0]));
    }
    return date;
  }

  formatDateForService(date: string) {
    // 04/2019 da trasformare in 2019-04
    let month = date.substring(3, 5);
    let year = date.substring(6);
    return year + "-" + month;
  }

  exportCSVFile(headers: any, items: any, fileTitle: any) {
    if (headers) {
      items.unshift(headers);
    }

    let jsonObject = JSON.stringify(items);

    let csv = this.convertToCSV(jsonObject);

    let exportedFilenmae = fileTitle + ".csv" || "export.csv";

    let blob = new Blob([csv], { type: "text/csv;charset=utf-8,%EF%BB%BF" });

    {
      let link = document.createElement("a");
      if (link.download !== undefined) {
        let url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", exportedFilenmae);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }
  convertToCSV(objArray: any) {
    let array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
    let str = "";

    for (const element of array) {
      let line = "";
      for (let index in element) {
        if (line != "") line += ",";

        line += element[index];
      }

      str += line + "\r\n";
    }

    return str;
  }

  updatePayloadGroupIfRequired(type: string, value: string | string[]) {
    if (
      this.settingsPayloadValue.payload.network.group.type === type &&
      toStringList(this.settingsPayloadValue.payload.network.group.value).join("|") ===
        toStringList(value).join("|")
    ) {
      this.settingsPayloadSubject.next({
        ...this.settingsPayloadValue,
        payload: {
          ...this.settingsPayloadValue.payload,
          network: {
            ...this.settingsPayloadValue.payload.network,
            group: { type: "", value: "" },
          },
        },
      });
      return true;
    } else {
      return false;
    }
  }

  genTempPayload(
    brands: string[] | undefined,
    regionSelected: string | undefined,
    subRegionSelected: string | undefined,
    market: string[] | undefined
  ) {
    performance.mark('genTempPayload-start');
    let temporaryPayload = new Payload();

    temporaryPayload.network.brand = brands && brands.length > 0 ? brands : [""];
    temporaryPayload.network.regions = [
      {
        region: regionSelected || "",
        subRegions: [{ market: market || [""], subregion: subRegionSelected || "" }],
      },
    ];
    temporaryPayload.network.dealer = [];
    temporaryPayload.period = this.settingsPayloadValue.payload.period;
    temporaryPayload.question = this.settingsPayloadValue.payload.question;
    temporaryPayload.vehicle = this.settingsPayloadValue.payload.vehicle;
    performance.mark('genTempPayload-end');
    performance.measure('genTempPayload', 'genTempPayload-start', 'genTempPayload-end');
    return temporaryPayload;
  }

  isMaserati(user: MeUser) {
    return user?.pathbrand === this.MASERATI_DEFAULT_BRAND;
  }

  isIapDealer(user: MeUser) {
    return user.region === this.IAP_DEFAULT_REGION && user.csiProfile === this.ROLE_DEALER;
  }
  isIapAdmin(user: MeUser) {
    return user.csiProfile === this.ROLE_IAP_ADMIN;
  }
  isIapDealerGroup(user: MeUser) {
    return user.region === this.IAP_DEFAULT_REGION && user.csiProfile === this.DEALER_GROUP;
  }

  isMeaDealer(user: MeUser) {
    return user.region === this.MEA && user.csiProfile === this.ROLE_DEALER;
  }
  isMeaImporter(user: MeUser) {
    return user.region === this.MEA && user.csiProfile === this.ROLE_IMPORTER;
  }
  isRoleHelpDesk(user: MeUser) {
    return (
      user.roles.includes("HD_DEALER_ES") ||
      user.roles.includes("HD_ROW") ||
      user.roles.includes("HD_NSC_ES") ||
      user.roles.includes("HD_SAR") ||
      user.region === "EUR" ||
      user.region === "EU"
    );
  }

  getHelpDesk(roles: string[], user: MeUser | null, market: string) {

    let euHelpDeskMail;
    let euHelpDeskPhone;
    let euHelpDeskPhone2 = "";
    let clockEur = null
    let textHelpDesk1: string = "";
    let textHelpDesk2: string = "";

    let region = user!.region;

    switch (market) {
      case "NL":
        euHelpDeskMail = "servicedesk-NLD@hdsupport.stellantis.com";
        euHelpDeskPhone = "(+31)(0)206971261";
        clockEur = "07.30 - 19.30"
        break;
      case "FR":
        euHelpDeskMail = "servicedesk-FRA@hdsupport.stellantis.com";
        euHelpDeskPhone = "(+33)(0)969391659";
        clockEur = "07.30 - 19.30"
        break;
      case "DE":
        euHelpDeskMail = "servicedesk-DEU@hdsupport.stellantis.com";
        euHelpDeskPhone = "(+49)61422935960";
        clockEur = "07.30 - 19.30"
        break;
      case "PT":
        euHelpDeskMail = "servicedesk-POR@hdsupport.stellantis.com";
        euHelpDeskPhone = "(+35)1219497872";
        clockEur = "07.30 - 19.30"
        break;
      case "IT":
        euHelpDeskMail = "servicedesk-ITA@hdsupport.stellantis.com";
        euHelpDeskPhone = "(+39)800166050";
        clockEur = "08.00 - 20.00"
        break;
      case "PL":
        euHelpDeskMail = "servicedesk-POL@hdsupport.stellantis.com";
        euHelpDeskPhone = "(+48)224442200 ";
        clockEur = "07.30 - 19.30"
        break;
      case "ES":
        euHelpDeskMail = "servicedesk-ESP@hdsupport.stellantis.com";
        euHelpDeskPhone = "(+34)918800368";
        clockEur = "08.00 - 20.00"
        break;
      case "BE":
        euHelpDeskMail = 'servicedesk-BEL@hdsupport.stellantis.com'
        euHelpDeskPhone = '(+32)(0)78050064'
        clockEur = "07.30 - 19.30"
        break;
      case "AT":
        euHelpDeskMail = 'servicedesk-AUT@hdsupport.stellantis.com'
        euHelpDeskPhone = '(+43)810970790'
        clockEur = "07.30 - 19.30"
        break;
      case "GB":
        euHelpDeskMail = "servicedesk-GBR@hdsupport.stellantis.com";
        euHelpDeskPhone = "(+44)(0)8456030637";
        clockEur = "07.30 - 19.30"
        break;
      case "BR":
        euHelpDeskMail = "";
        textHelpDesk1 = "PEUGEOT / CITROEN :";
        euHelpDeskPhone = "0800721-6606";
        textHelpDesk2 = "FIAT / JEEP / RAM :"
        euHelpDeskPhone2 = "+(55)(31)2123-8500";
        clockEur = "8:00 - 17:30"
        break;
      case "AR":
        textHelpDesk1 = "PEUGEOT / CITROËN / DS :";
        euHelpDeskPhone = "0800721-6606";
        textHelpDesk2 = "FIAT / JEEP / RAM :";
        euHelpDeskPhone2 = "3428 (FIAT)  |  02002223428(FIAT)";
        euHelpDeskMail = "helpdesk.argentina@fcagroup.com";
        clockEur = ""
        break;
      case "CL":
        textHelpDesk1 = "PEUGEOT / OPEL:";
        euHelpDeskMail = "soporte-infored@stellantis.com";
        euHelpDeskPhone = "";
        clockEur = ""
        break;
      default:
        euHelpDeskMail = "";
        euHelpDeskPhone = "";
    }

    if (this.applicationService.navBarSelectValue?.idItem.includes('CEC')) {
      euHelpDeskMail = 'https://fiatchrysler.service-now.com';
      return of({
        email: `<a class="flex flex-row justify-start items-center p-1 py-2 w-full outline-none" href="${euHelpDeskMail}"><div>${this.traslatei18n(
          "Web page"
        )} :</div> <div class="text-lg px-1 text-gray-500 cursor-pointer">${euHelpDeskMail}</div></a>`,
      })
    }
    if (user!.csiProfile === Role.STLA_DR || user!.csiProfile === Role.STLA_DR_HQ || user!.csiProfile === Role.DEALER_DR) {
      return of({
        link: `<a class="flex flex-row justify-center items-center p-1 py-2 w-full outline-none  cursor-pointer" target=”_blank”   href="https://roarfocusplatform.com/">${this.traslatei18n(
          "click here"
        )}</a>`,
      });
    }
    if (region === "EUR" || region === "EU" || roles.includes("HD_SAR") && (market !== 'BR' && market !== 'AR' && market !== 'CL')) {
      return of({
        phone: `
            <a class="flex flex-row justify-start items-center p-1 py-2 w-full outline-none" href="tel:${euHelpDeskPhone}"><div>${this.traslatei18n(
          "Telephone"
        )} :</div> <div class="text-lg px-1 text-gray-500">${euHelpDeskPhone}</div></a>`,
        email: euHelpDeskMail ? `<a class="flex flex-row justify-start items-center p-1 py-2 w-full outline-none" href="mailto:${euHelpDeskMail}"><div>${this.traslatei18n(
          "Email"
        )} :</div> <div class="text-lg px-1 text-gray-500 cursor-pointer">${euHelpDeskMail}</div></a>` : "",
        clock: `<div class="text-lg px-1 text-gray-500 cursor-pointer mt-2 w-full justify-center items-center flex flex-row ">${clockEur ? clockEur : ''}</div></a>`
      });
    }

    if (roles.includes("HD_DEALER_ES")) {
      return of({
        phone: `
        <a class="flex flex-row justify-start items-center p-1 py-2 w-full outline-none" href="tel:+34918800368"><div>${this.traslatei18n(
          "Telephone"
        )} :</div> <div class="text-lg px-1 text-gray-500">+34918800368</div></a>`,
        email: `<a class="flex flex-row justify-start items-center p-1 py-2 w-full outline-none" href="mailto:servicedesk-ESP@hdsupport.stellantis.com"><div>${this.traslatei18n(
          "Email"
        )} :</div> <div class="text-lg px-1 text-gray-500 cursor-pointer">servicedesk-ESP@hdsupport.stellantis.com</div></a>`,
        chat: `<a class="flex flex-row justify-start items-center p-1 py-2 w-full outline-none">Chat : On LinkEntry</a>
        <div class="flex flex-row justify-start items-center py-2 p-1">Horario de atención: 08:00 - 20:00</div>`,
        link: null,
      });
    }
    if (roles.includes("HD_NSC_ES")) {
      return of({
        link: `<a class="flex flex-row justify-center items-center p-1 py-2 w-full outline-none cursor-pointer" target=”_blank”  href="https://fiatchrysler.service-now.com/">DriveIT https://fiatchrysler.service-now.com/, by opening an INCIDENT/REQUEST and assigning it to ROAR group</a>`,
      });
    }
    if (roles.includes("HD_ROW") && (market !== 'BR' && market !== 'AR' && market !== 'CL')) {
      return of({
        link: `<a class="flex flex-row justify-center items-center p-1 py-2 w-full outline-none  cursor-pointer" target=”_blank”   href="https://roarfocusplatform.com/">${this.traslatei18n(
          "click here"
        )}</a>`,
      });
    }

    if (market === 'BR' || market === 'AR' || market === 'CL') {
      return of({
        brand1: `
            <a class="flex flex-row justify-start items-center p-1 py-2 w-full outline-none" href="tel:${textHelpDesk1}"><div>${this.traslatei18n(
          ""
        )} </div> <div class="text-lg px-1 text-gray-500">${textHelpDesk1}</div></a>`,
        phone: euHelpDeskPhone ? `
          <a *ngIf="euHelpDeskPhone" class="flex flex-row justify-start items-center p-1 py-2 w-full outline-none" href="tel:${euHelpDeskPhone}">
            <div>${this.traslatei18n("Telephone")} :</div>
            <div class="text-lg px-1 text-gray-500">${euHelpDeskPhone}</div>
          </a>` : '',
        brand2: `
            <a class="flex flex-row justify-start items-center p-1 py-2 w-full outline-none" href="tel:${textHelpDesk2}"><div>${this.traslatei18n(
          ""
        )} </div> <div class="text-lg px-1 text-gray-500">${textHelpDesk2}</div></a>`,
        phone2: euHelpDeskPhone2 ? `
          <a *ngIf="euHelpDeskPhone2" class="flex flex-row justify-start items-center p-1 py-2 w-full outline-none" href="tel:${euHelpDeskPhone2}">
            <div>${this.traslatei18n("Telephone")} :</div>
            <div class="text-lg px-1 text-gray-500">${euHelpDeskPhone2}</div>
          </a>` : '',
        email: euHelpDeskMail ? `
          <a class="flex flex-row justify-start items-center p-1 py-2 w-full outline-none" href="mailto:${euHelpDeskMail}">
            <div>${this.traslatei18n("Email")} :</div>
            <div class="text-lg px-1 text-gray-500 cursor-pointer">${euHelpDeskMail}</div>
          </a>` : '',
        clock: `<div class="text-lg px-1 text-gray-500 cursor-pointer mt-2 w-full justify-center items-center flex flex-row ">${clockEur ? clockEur : ''}</div></a>`
      });
    }
    // if (roles.includes("HD_SAR")) {
    //   return of({
    //     link: `<a class="flex flex-row justify-center items-center p-1 py-2 w-full outline-none  cursor-pointer" target=”_blank”  href="https://roarfocusplatform.com/help-desk-form-short/">${this.traslatei18n(
    //       "click here"
    //     )}</a>`,
    //   });
    // }

    return of({});
  }

  searchElementMeDealer(me: MeUser, dealer: any) {
    let scopes: { key: string; value: string }[] = [];
    let regions: { key: string; value: string }[] = [];
    me.menu.forEach((item) => {
      scopes.push({ key: item.idItem, value: item.displayName });
    });

    let brands: FilterBrand[] = me?.scopeEntities?.network?.brand.map((el: string) => ({
      key: el.substring(2),
      value: el,
    }));
    brands.sort((a: FilterBrand, b: FilterBrand) =>
      this.traslatei18n(a.view) < this.traslatei18n(b.view) ? -1 : 1
    );
    let markets: { key: string; value: string }[] = [];
    const marketsSet = new Set<string>();
    me.scopeEntities.network.regions.forEach((el: any) => {
      regions.push({ key: el.region, value: el.region });

      if (el.subRegions[0].market.length > 0) {
        el.subRegions[0].market.forEach((el: string) => {
          if (!marketsSet.has(el)) {
            marketsSet.add(el);
            markets.push({ key: el, value: el });
          }
        });
      } else {
        dealer
          .filter((el: any) => el.region === el.region)
          .forEach((item: any) => {
            let obj = { key: item.market, value: item.market };
            if (!marketsSet.has(obj.key)) {
              marketsSet.add(obj.key);
              markets.push(obj);
            }

          });
      }
    });

    // let markets: { key: string; value: string }[] = [];

    let dealerList: { key: string; value: string }[] = [];
    dealer.map((item: any) => {
      dealerList.push({ key: item.dealerCode, value: item.name });
    });

    return { scopes: scopes, regions: regions, markets: markets, dealer: dealerList, brands: brands };
  }

  public exportAsExcelFile(json: any[], excelFileName: string): void {

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);

    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    //const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });

    FileSaver.saveAs(data, fileName + '_export_' + new Date().toLocaleDateString(this.applicationService.languageSelectValue) + EXCEL_EXTENSION);
  }
}
